import * as parent from '../variables';
import { IS_ADMIN } from '../../constants/validation';

export const colors = {
  ...parent.colors,
  PRIMARY_MAIN: '#001127',
  PRIMARY_MODAL_MAIN: '#19192d',
  HEADER_COUNT_TEXT: '#fff',
  PRIMARY_CONTRAST: '#fff',
  PRIMARY_BORDER: '#2C3249',
  PRIMARY_HEADER_RIGHT_BORDER: '#07428b',
  GREY: '#999',
  DAILY_LOG_GRAPH_BORDER: '#919191',
  NORMAL_LINK: '#b0b0b0',
  MODAL_TEXT: '#797979',
  MODAL_HEADING: '#fff',
  MODAL_BACKGROUND: '#19192d',
  LIST_TEXT: '#fffff',
  HEADER_LIST_TEXT: '#b4b7c0',
  LIGHT_BORDER: '#2d2b2b',
  SECONDARY_MAIN: '#00B35A',
  WHITE: '#fff',
  INPUT_BACKGROUND: '#001127',
  RED: '#ff0000',
  BLACK: '#000',
  BACKGROUND: '#1b1b1b',
  BLACK_THREE: '#373737',
  RED_TWO: '#d34343',
  GREEN: '#32cd32',
  GREEN_TWO: '#97AE46',
  GREY_ELEVEN: '#777070',
  GREY_TWELVE: '#c3c3c3',
  BLACK_FOUR: '#333333',
  GRAPH_BLACK: '#212121',
  CHART_BLUE: '#00e2ff',
  CHART_PURPLE: '#ff85ff',
  CHART_GREEN: '#c1ffe2',
  CHART_PINK: '#efa6ff',
  CHART_YELLOW: '#fff3b7',
  CHART_LIGHT_BLUE: '#b8dcff',
  WARNING: '#ffff00',
  GREY_DATA: '#696969',
  SELECTED_TAB_COLOR: '#00B35A',
  LINK_COLOR: '#00B35A',
  HEADER_COLOR: '#001630',
  SELECTED_MENU_BG: '#001630',
  DOCUMENT_LINE: '#2C3249',
  INPUT_BORDER: 'rgba(255,255,255,0.3)',
  DISABLED_COLOR: '#889ccc',
  RADIO_BACKGROUND: '#001127',
  FORM_COLOR: '#dbdbdb',
  SUGGESTED_COLOR: '#00b7a0',
  BODY_BACKGROUND: IS_ADMIN ? '#001127' : '#19192d',
  ACCORDION_BODY_BACKGROUND: '#001127',
  CHECKBOX_TICK: '#00B35A',
  PAGINATION_HEAD_BACKGROUND: '#001127',
  PAGINATION_BACKGROUND: '#001630',
  PAGINATION_COLOR: '#fff',
  SELECTED_AREA: 'rgba(32, 177, 232, 0.6)',
  MAP: {
    LIGHT_BLACK: '#323232',
    LIGHTER_BLACK: '#444444',
    BLACK: '#242424',
    GREY: '#d1d1d1',
    LIGHT_GREY: '#d1d1d1',
    LIGHTER_GREY: '#d1d1d1',
    WATER: '#1b2f46',
    ROAD: '#37425C',
  },
  LOGIN_BUTTON: '#00B35A',
  TITLE_COLOR: '#fff',
  INPUT_COLOR: '#fff',
  INPUT_FOCUS: '#5ab8f9',
  TAB_LABEL: '#455560',
  BACKGROUND_MENU: '#2e3650',
  PAGINATION_ALTERNATE_BACKGROUND: '#021e40',
  TABLE_ROW_COLOR: 'rgba(222, 231, 255, 0.75)',
  SORT_ICON: '#00B35A',
  LOGOUT_BUTTON: '#202b58',
  PAGINATION_HEADER: '#bfc3c8',
  HEADER_TEXT: '#fff',
  PAGINATION_BORDER: '#16263a',
  RESET_BUTTON: '#516072',
  RESET_BACKGROUND: '#516072',
  ACTION_BORDER: 'rgba(255, 255, 255, 0.66)',
  PRIMARY_BUTTON_TEXT: '#fff',
  FORM_INPUT_BG: '#001127',
  FORM_BACKGROUND: '#001127',
  CHECKBOX_BORDER: 'rgba(255,255,255,0.3)',
  TABEL_HEAD_BOTTOM_COLOR: '#dfe3eb33',
  SELECT_ACTIONS: '#fff',
  SECONDARY_BORDER: '#2C3249',
  MULTISELECT_BACKGROUND: '#001127',
  MULTISELECT_LABEL: '#fff',
  TAB_HIGHLIGHT: '#fff',
  TAB_HIGHLIGHT_BACKGROUND: '#021e40',
  TAB_BOTTOM_BORDER: '#00B35A',
  ACCORDION_BACKGROUND: '#001127',
  USER_LOGO_BACKGROUND: '#03264e',
  USER_LOGO_COLOR: '#00B35A',
  MENU_BACKGROUND: '#001630',
  MENU_TITLE: 'rgba(255, 255, 255, 0.8)',
  SELECTED_MENU_TITLE: '#fff',
  MENU_BORDER_COLOR: '#00B35A',
  POLICIES_BACKGROUND: '#001127',
  RANGE_PICKER: {
    CELL_BG: '#585858',
    CELL_HOVER_BG: '#333333',
  },
  NEW_SUBMENU_HEADER: true,
  ...(IS_ADMIN
    ? { LOGIN_BACKGROUND: '#001630', TAB_HIGHLIGHT_BACKGROUND: '#2e3650', BACKGROUND_MENU: '#2e3650' }
    : { ACCORDION_BODY_BACKGROUND: '#001127' }),
};
export default colors;
export const fonts = ['Open Sans', 'sans-serif'].join(',');
